export default {
  "pl": {
    "activity": {
      "attributes": {
        "end": "Koniec",
        "now": "Teraz",
        "title": "Nowe aktywności"
      },
      "labels": {
        "not_opened_yet": "Jeszcze nie widziano"
      },
      "projects": {
        "announcement": {
          "create": "utworzył(a) post z aktualnościami."
        },
        "building": {
          "create": "utworzył(a) budynek: <i>{notifiable_name}</i>."
        },
        "document": {
          "create": "przesłał(a) dokument: <i>{notifiable_name}</i>."
        },
        "lot": {
          "create": "utworzył(a) działkę: <i>{notifiable_name}</i>."
        },
        "phase": {
          "create": "utworzył(a) fazę: <i>{notifiable_name}</i>."
        },
        "published": {
          "customer": "opublikował(a) dla klienta decyzję: <i>{notifiable_name}</i>.",
          "partners": "opublikował(a) dla partnera(-ów) decyzję: <i>{notifiable_name}</i>."
        },
        "question": {
          "create": "utworzył(a) pytanie <i>{notifiable_name}</i> w FAQ: <i>{group_name}</i>."
        },
        "space": {
          "create": "utworzył(a) przestrzeń: <i>{notifiable_name}</i>.",
          "update": "przypisał(a) do jednostki przestrzeń: <i>{notifiable_name}</i>."
        },
        "survey_type": {
          "create": "utworzył(a) ankietę typu: <i>{notifiable_name}</i>."
        },
        "ticket": {
          "create": "zainicjował(a) rozmowę: <i>{notifiable_name}</i>."
        },
        "unit": {
          "assign": "przypisał(a) do klienta: <i>{notifiable_name}</i>.",
          "create": "utworzył(a) jednostkę: <i>{notifiable_name}</i>.",
          "invisibled": "anulował(a) dostęp klienta do: <i>{notifiable_name}</i>.",
          "unassign": "anulował(a) przypisanie klienta do: <i>{notifiable_name}</i>.",
          "visibled": "udzielił(a) klientowi dostępu do: <i>{notifiable_name}</i>."
        }
      },
      "units": {
        "announcement": {
          "create": "utworzył(a) post z aktualnościami."
        },
        "decision": {
          "create": "utworzył(a) decyzję: <i>{notifiable_name}</i>.",
          "published": {
            "customer": "opublikował(a) dla klienta decyzję: <i>{notifiable_name}</i>.",
            "partners": "opublikował(a) dla partnera(-ów) decyzję: <i>{notifiable_name}</i>."
          }
        },
        "decision_document": {
          "create": "przesłał(a) dokument: <i>{notifiable_name}</i> dotyczący decyzji: <i>{group_name}</i>."
        },
        "decision_proposal": {
          "approved": "zaakceptował(a) ofertę: <i>{notifiable_name}</i> dotyczącą decyzji: <i>{group_name}</i>.",
          "create": {
            "customer": "udostępniona propozycja <i>„{notifiable_name}”</i> z klientem.",
            "employee": "utworzona propozycja <i>„{notifiable_name}”</i>.",
            "partnergroup": "wspólna propozycja <i>„{notifiable_name}”</i> z partnerem <i>{target_name}</i>."
          },
          "unapproved": "niezatwierdzona propozycja <i>'{notifiable_name}'</i> w decyzji <i>'{group_name}'</i>.",
          "updated": "zaktualizowana propozycja <i>'{notifiable_name}'</i> w decyzji <i>'{group_name}'</i>."
        },
        "document": {
          "create": "przesłał(a) dokument: <i>{notifiable_name}</i>."
        },
        "proposal": {
          "deleted": "usunięta propozycja <i>'{notifiable_name}'</i>."
        },
        "question": {
          "create": "utworzył(a) pytanie <i>{notifiable_name}</i> w FAQ: <i>{group_name}</i>."
        },
        "space": {
          "update": "przypisał(a) do tej jednostki przestrzeń: <i>{notifiable_name}</i>."
        },
        "survey": {
          "create": "utworzył(a) ankietę: <i>{notifiable_name}</i>.",
          "published": "opublikował(a) ankietę: <i>{notifiable_name}</i>."
        },
        "ticket": {
          "create": "zainicjował(a) rozmowę: <i>{notifiable_name}</i>."
        },
        "unit": {
          "assign": "przypisał(a) do klienta: <i>{notifiable_name}</i>.",
          "invisibled": "anulował(a) dostęp klienta do: <i>{notifiable_name}</i>.",
          "unassign": "anulował(a) przypisanie klienta do: <i>{notifiable_name}</i>.",
          "visibled": "udzielił(a) klientowi dostępu do: <i>{notifiable_name}</i>."
        }
      }
    }
  }
}
